import { getFetchedDataPayload } from '../../../../../utils/fetched-data/get-fetched-data-payload';
import { loyaltyDomainStore } from '../../../store';
export const memberHasWatchlistFilm = (filmId) => {
    const watchlistFilms = getFetchedDataPayload(loyaltyDomainStore.data.memberWatchlistFilmsById);
    return watchlistFilms && !!watchlistFilms[filmId];
};
